// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","966":"login"}[chunkId] + "-legacy." + {"594":"09df38b4","966":"3083a895"}[chunkId] + ".js";
};